import React, {useState, useEffect, useCallback} from 'react';
import s from './index.module.css';
import {getIsDevEnv, getIsTestingEnv, getIsLocalEnv} from '../../../store/selectors';
import {
  getCurrentDialogId,
  getVisitorId,
} from '../../../store/selectors';
import { useSelector } from 'react-redux';

const SMARTBE_NOTIFICATOR_LINK_LOCAL = 'http://localhost:8070/api';
const SMARTBE_NOTIFICATOR_LINK_DEV = 'https://dev.smartbe.ru/notificator/api';
const SMARTBE_NOTIFICATOR_LINK_TEST = 'https://test.smartbe.ru/notificator/api';
const SMARTBE_NOTIFICATOR_LINK_PROD = 'https://smartbe.ru/notificator/api';

// Новый компонент формы сбора контактов
const ContactForm = ({ onSubscribe, telegramLink }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState('telegram'); // 'email' или 'telegram'
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      setIsLoading(true);
      try {
        await onSubscribe(email);
        setSubmitted(true);
        setError(null);
      } catch (err) {
        setError('Произошла ошибка при отправке. Пожалуйста, попробуйте позже.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (submitted) {
    return (
      <div className={s.contactForm}>
        <div className={s.successMessage}>
          Спасибо! Мы уведомим вас, когда эксперт ответит.
        </div>
      </div>
    );
  }

  return (
    <div className={s.contactForm}>
      <div className={s.contactFormHeader}>
        Эксперт пока не ответил. Хотите получить уведомление?
      </div>

      <div className={s.tabs}>
        <button
          className={`${s.tab} ${activeTab === 'telegram' ? s.activeTab : ''}`}
          onClick={() => setActiveTab('telegram')}
        >
          В Telegram
        </button>
        <button
          className={`${s.tab} ${activeTab === 'email' ? s.activeTab : ''}`}
          onClick={() => setActiveTab('email')}
        >
          По email
        </button>
      </div>

      {activeTab === 'email' ? (
        <form onSubmit={handleSubmit} className={s.form}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Ваш email"
            className={s.emailInput}
            required
          />
          <button type="submit" className={s.submitButton} disabled={isLoading}>
            {isLoading ? 'Отправка...' : 'Получить ответ'}
          </button>
          {error && <div className={s.errorMessage}>{error}</div>}
        </form>
      ) : (
        <div className={s.telegramBlock}>
          <div className={s.telegramText}>
            Получайте уведомления быстрее через Telegram-бота
          </div>
          <a
            href={telegramLink}
            target="_blank"
            rel="noopener noreferrer"
            className={s.telegramButton}
          >
            Подписаться на бота
          </a>
          <div className={s.telegramHint}>
            Просто нажмите кнопку и начните диалог с ботом
          </div>
        </div>
      )}
    </div>
  );
};


const LayoutNotification = ({ className }) => {
  const visitorId = useSelector(getVisitorId);
  const currentDialogIdd = useSelector(getCurrentDialogId);
  const isDevEnv = useSelector(getIsDevEnv);
  const isLocalhostEnv = useSelector(getIsLocalEnv);
  const isTestingEnv = useSelector(getIsTestingEnv);
  let notificatorLink = SMARTBE_NOTIFICATOR_LINK_PROD;
  if (isDevEnv)
  {
    notificatorLink = SMARTBE_NOTIFICATOR_LINK_DEV;
  }
  else if (isTestingEnv)
  {
    notificatorLink = SMARTBE_NOTIFICATOR_LINK_TEST;
  }
  else if (isLocalhostEnv)
  {
    notificatorLink = SMARTBE_NOTIFICATOR_LINK_LOCAL;
  }

  const [expertNotResponding, setExpertNotResponding] = useState(false);
  const [telegramLink, setTelegramLink] = useState(null);
  const generateTelegramLink = useCallback(async () => {
    try {
      const response = await fetch(
        `${notificatorLink}/generate-invite?visitorName=${visitorId}&dialogId=${currentDialogIdd}`,
        {
          method: 'GET',
          headers: {
            'accept': 'application/json',
          },
        }
      );

      const data = await response.json();
      return data.invite_link;
    } catch (error) {
      console.error('Error generate-invite:', error);
      throw error;
    }
  }, [visitorId, currentDialogIdd, notificatorLink]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setExpertNotResponding(true);
    }, 30000); // 30 секунд

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!telegramLink && currentDialogIdd && visitorId && expertNotResponding) {
      generateTelegramLink()
        .then(link => {
            setTelegramLink(link);
        })
        .catch(error => {
            console.error(error);
        });
    }

    return () => { };
  }, [expertNotResponding, telegramLink, generateTelegramLink, currentDialogIdd, visitorId]);

  const handleSubscribe = async (email) => {
    try {
      const response = await fetch(
        `${notificatorLink}/save-email?visitorName=${visitorId}&dialogId=${currentDialogIdd}&email=${encodeURIComponent(email)}`,
        {
          method: 'GET',
          headers: {
            'accept': 'application/json',
          },
        }
      );

      if (response.status !== 201) {
        console.error('Error saving email:', response);
        throw new Error('Failed to save email');
      }
    } catch (error) {
      console.error('Error saving email:', error);
      throw error;
    }
  };

  return (
    <div className={className}>
      <div className={s.rightSideInfo}>
        {expertNotResponding && (
          <ContactForm
            onSubscribe={handleSubscribe}
            telegramLink={telegramLink}
          />
        )}
      </div>
    </div>
  )
};

export default LayoutNotification;
